export function getCharacterLimitColor(remaining: number): string {
  if (remaining <= 10) return "error.main";
  if (remaining <= 20) return "#ff9800";
  return "text.secondary";
}